module.exports = __webpack_public_path__ + "static/media/loader-success.bf58ee5b.gif";